import React from "react";
import {
    Container,
    Row, 
    Col,
} from "react-bootstrap";
import ReactGA from 'react-ga';
export default function SuperPractice (){
    ReactGA.pageview(window.location.pathname + window.location.search);    
    return (

        <Container className='mt-5 mb-5'>
                        <h1 className='text-center'>Super Practice benefits</h1>
        <Row xs={1} md={2} lg={2} > 
        <Col className="mt-5 mb-5" >
            <h4>Super Practice benefits</h4>
            <h5>We’ll add a Super Practice badge to your profile to build trust with patients and make your practice stand out from the crowd.</h5>
        </Col>
        <Col className="mt-5 mb-5" >
            <h4>Super Practice benefits</h4>
            <h5>Increased visibility and trust mean more patients. More patients mean more money for your practice.</h5>
        </Col>
        </Row>
        <h1 className='text-center'>How to become a Super Practice</h1>
        <Row xs={1} md={2} lg={2} > 
        <Col className="mt-5 mb-5" >
            <h4>4.8 star rating</h4>
            <h5>Super Practices maintain a patient rating of 4.8 or higher. These practices consistently provide outstanding experiences and patients leave glowing reviews to reflect that.</h5>
        </Col>
        <Col className="mt-5 mb-5" >
            <h4>5+ appointments completed monthly</h4>
            <h5>Super Practices treat at least 5 Opencare patients each month. Opencare prides itself on connecting quality patients with quality dentists. Patients love experienced practices after all.</h5>
        </Col>
        </Row>
        </Container>
    )
}


